import React, { useState } from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { useTranslation } from 'react-i18next';
import { Button, SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
const NotifyClaimUsersModal = _ref => {
  let {
    show,
    onHide,
    onSubmit,
    users,
    title,
    mode = 'create'
  } = _ref;
  const {
    t
  } = useTranslation();
  const [selectedUserIds, setSelectedUserIds] = useState(() => users.map(u => u.id));
  const uniqueUsers = users.filter((user, index, self) => user && index === self.findIndex(u => u.id === user.id));
  const toggleUser = userId => {
    setSelectedUserIds(prev => prev.includes(userId) ? prev.filter(id => id !== userId) : [...prev, userId]);
  };
  const handleSubmit = sendEmail => {
    onSubmit(sendEmail ? selectedUserIds : []);
    setSelectedUserIds(uniqueUsers.map(u => u.id));
  };
  const skipButtonText = mode === 'update' ? t('save_without_sending_email') || 'Save without sending email' : t('create_claim_without_sending_email') || 'Create claim without sending email';
  const skipHeadingText = mode === 'update' ? t('skip_email_notification') || 'Skip email notification' : t('skip_email_notification') || 'Skip email notification';
  return /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    show: show,
    title: title || t('notify_users_of_new_claim') || 'Notify Users of New Claim',
    onHide: onHide,
    renderBody: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
      className: "mb-3 p-3"
    }, /*#__PURE__*/React.createElement("h5", null, t('send_new_claim_email_notification') || 'Send the new claim email notification to the following people'), /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
      as: Row,
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Col, {
      md: 12
    }, uniqueUsers.map(user => /*#__PURE__*/React.createElement(Form.Check, {
      type: "checkbox",
      key: user.id,
      id: "notify-user-".concat(user.id),
      label: "".concat(user.name, " (").concat(user.email, ")"),
      checked: selectedUserIds.includes(user.id),
      onChange: () => toggleUser(user.id)
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "text-end"
    }, /*#__PURE__*/React.createElement(SaveButton, {
      variant: "info",
      iconPosition: "left",
      icon: "mail",
      text: t('send_email_notification'),
      disabled: selectedUserIds.length === 0,
      onClick: () => handleSubmit(true)
    }))), /*#__PURE__*/React.createElement(Card, {
      className: "p-3"
    }, /*#__PURE__*/React.createElement("h5", null, skipHeadingText), /*#__PURE__*/React.createElement("div", {
      className: "text-end"
    }, /*#__PURE__*/React.createElement(SaveButton, {
      variant: "secondary",
      text: skipButtonText,
      onClick: () => handleSubmit(false)
    }))))
  });
};
export default NotifyClaimUsersModal;